'use client';

import {Box, styled} from '@mui/material';

export const StyledIframeContainer = styled(Box)(({theme}) => ({
  width: '100%', maxWidth: theme.breakpoints.values.md, margin: 'auto', padding: theme.spacing(0, 2, 8, 2),
}));